import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import { Card, Stack, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AuthenticationTransKey } from "../../localization/translation-key/authentication";
import logoSrc from "../../logo.svg";
import { useStores } from "../../mobx-stores/_root-store";
import { ImageSkeleton } from "../../share-components/atomics/image-skeleton";
import { XButton } from "../../share-components/mui-wrap/button/x-button";
import { XTextField } from "../../share-components/mui-wrap/text-field/x-text-field";
export const LoginPage = observer(() => {
  const {
    authentication: { setProp },
  } = useStores();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const onAuthenHandler = useCallback(() => {
    setProp("isAuthenticated", true);
    navigate("/", { replace: true });
  }, [navigate, setProp]);
  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      justifyContent={"center"}
      sx={{ height: "100vh", width: "100vw" }}
    >
      <Card
        sx={{
          minWidth: "380px",
          padding: "24px",
        }}
      >
        <Stack spacing={3}>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Stack direction={"row"} spacing={1} alignItems={"center"}>
              <ImageSkeleton
                src={logoSrc}
                alt="logo"
                height={60}
                width={60}
              ></ImageSkeleton>
              <Typography
                variant="h6"
                fontWeight={(theme) => theme.typography.fontWeightRegular}
              >
                My app
              </Typography>
            </Stack>
          </Stack>

          <Stack>
            <Typography>Log in with your username and password:</Typography>
          </Stack>
          <Stack spacing={2} marginTop={"10px"}>
            <XTextField label="Username" fullWidth showclearicon></XTextField>
            <XTextField label="Password" fullWidth type="password"></XTextField>
          </Stack>
          <Stack>
            <XButton variant="text">
              {t(AuthenticationTransKey.forgotPw)}
            </XButton>
          </Stack>
          <Stack>
            <XButton variant="contained" onClick={onAuthenHandler}>
              {t(AuthenticationTransKey.login)}
              <ArrowRightAltOutlinedIcon
                sx={{ marginLeft: "5px" }}
              ></ArrowRightAltOutlinedIcon>
            </XButton>
          </Stack>
        </Stack>
      </Card>
    </Stack>
  );
});
